import { saveAs } from 'file-saver';
import { AxiosResponse } from 'axios';

/**
 * Guarda en disco la respuesta binaria de una descarga.
 *
 * El nombre del archivo lo decide el backend; viaja en la cabecera `X-Filename` porque
 * `Content-Disposition` no es legible desde JavaScript cuando la peticion es de otro origen.
 * Si no llega, se usa el nombre de respaldo.
 *
 * @param response      Respuesta de axios pedida con `responseType: 'blob'`.
 * @param fallbackName  Nombre a usar cuando el backend no informa uno.
 */
export const saveResponseAsFile = (response: AxiosResponse<Blob>, fallbackName: string): void => {
    const headerName = response.headers?.['x-filename'] as string | undefined;
    saveAs(response.data, headerName && headerName.trim() ? headerName : fallbackName);
};
